import { ok } from '../functions/ok';
import { err } from '../functions/err';
import type { Result, AppError } from '../types';

/**
 * @group Functions
 * @summary <blockquote>Executes a synchronous function and returns a Result.</blockquote>
 * @typeParam T - The type of the successful value.
 * @typeParam E - The type of the error (defaults to AppError).
 * @param fn - The function to execute.
 * @returns An Ok if successful, or an Err if an exception is thrown.
 * @example
 * ```typescript
 * const result = tryCatch(() => {
 *   return riskyOperation();
 * });
 * ```
 */
export function tryCatch<T, E = AppError>(fn: () => T): Result<T, E> {
  try {
    return ok(fn());
  } catch (error) {
    return err(error as E);
  }
} 